// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReactionLive_wrapper_2wMqd","wrapper--full":"ReactionLive_wrapper--full_2mpO5"};